import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { handlePdf, PDF_ACTION } from "./pdfHelper"
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../component/constent";
export const generateReportPDF = ({
  title,
  columns,
  rows,
  fileName = "Report",
  header = "MECHANICAL WORKSHOP, GORAKHPUR",
  footer = "Generated by Workshop Management System",
  reportInfo = [],
}) => {
  const doc = new jsPDF("p", "mm", "a4");

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Calculate dynamic header height
  const headerStartY = 36;
  const reportInfoHeight = reportInfo.length * 5;
  const lineY = Math.max(40, headerStartY + reportInfoHeight);
  const tableStartY = lineY -10 ;

  autoTable(doc, {
    head: [columns],

    body: rows,
...PDF_TABLE_STYLE,
    startY: tableStartY,

    margin: {
       top: tableStartY,
      left: 12,
      right: 12,
      bottom: 18,
    },

   

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      cellPadding: 2,
      valign: "middle",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      fontStyle: "bold",
      halign: "center",
    },

    willDrawPage: function (data) {
      // ================= HEADER =================

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);

      doc.text(header, pageWidth / 2, 12, {
        align: "center",
      });

      doc.setFontSize(13);

      doc.text(title, pageWidth / 2, 20, {
        align: "center",
      });

      // Report Information
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);

      let y = headerStartY;

      reportInfo.forEach((item) => {
        doc.text(item, 12, y);
        y += 5;
      });

      // Header Separator
      doc.line(12, lineY-12, pageWidth - 12, lineY-12);

      // ================= FOOTER =================

      doc.line(
        12,
        pageHeight - 12,
        pageWidth - 12,
        pageHeight - 12
      );

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);

      // Generated Date
      doc.text(
        `Generated: ${new Date().toLocaleString()}`,
        12,
        pageHeight - 5
      );

      // Footer Text
      doc.text(
        footer,
        pageWidth / 2,
        pageHeight - 5,
        {
          align: "center",
        }
      );

      // Page Number
      doc.text(
        `Page ${data.pageNumber}`,
        pageWidth - 12,
        pageHeight - 5,
        {
          align: "right",
        }
      );
    },
  });

 // doc.save(`${fileName}.pdf`);
 handlePdf(doc, PDF_ACTION.VIEW);
};